import {Box, Button, Container, IconButton, Link, Paper, Stack, Typography, useMediaQuery} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import PeppermillFooter from "../Icons/PeppermillFooter";
import Bancontact from "../Icons/Bancontact";
import Visa from "../Icons/Visa";
import Mastercard from "../Icons/Mastercard";
import Paysafecard from "../Icons/Paysafecard";
import Kansspelcommissie, {CommissionDesJeuxDeHasard, GamingCommission} from "../Icons/Kansspelcommissie";
import MinimumAgeCasino from "../Icons/MinimumAgeCasino";
import GokMetMate from "../Icons/GokMetMate";
import HundredPercentSafe from "../Icons/HundredPercentSafe";
import FastPayments from "../Icons/FastPayments";
import BelgiumTag from "../Icons/BelgiumTag";
import AlwaysPlayLegally from "../Icons/AlwaysPlayLegally";
import {useTranslation} from "react-i18next";
import {CustomLink} from "../CustomLink/CustomLink";
import i18n from "i18next";
import Facebook from "../Icons/Facebook";
import Instagram from "../Icons/Instagram";
import React from "react";
import {ScreenReaderSpan} from "../ScreenReaderSpan/ScreenReaderSpan";
import {css} from "@linaria/core";
import {media} from "../../utils/responsive";

export const Footer = () => {
    const {t} = useTranslation();
    return (
        <footer>
            <div className={css`min-height: 280px;
              width: 100%;
              background-color: #000`}>
                <Container maxWidth={'lg'} sx={{display: 'flex', justifyContent: 'center'}}>
                    <div className={css`display: flex;
                      flex-direction: column;
                      width: 100%;`}>
                        <CustomLink to="/deposit">
                            <ScreenReaderSpan>{t('deposit')}</ScreenReaderSpan>
                            <div
                                className={css`display: flex;
                                  flex-direction: row;
                                  align-items: center;
                                  justify-content: space-around;
                                  width: 100%;
                                  margin-top: 16px`}>
                                <div
                                    className={css`padding: 0 8px;
                                      height: 32px;

                                      ${media.sm} {
                                        height: calc(32px * 1.4)
                                      }
                                    ;
                                      background-color: #fff;
                                      border-radius: 4px`}>
                                    <Bancontact sx={{
                                        width: {xs: '40px', sm: 'calc(40px * 1.4)'},
                                        height: {xs: '34px', sm: 'calc(34px * 1.4)'}
                                    }}/>
                                </div>
                                <div
                                    className={css`padding: 0 8px;
                                      height: 32px;

                                      ${media.sm} {
                                        height: calc(32px * 1.4)
                                      }
                                    ;
                                      background-color: #fff;
                                      border-radius: 4px`}>
                                    <Visa sx={{
                                        width: {xs: '40px', sm: 'calc(40px * 1.4)'},
                                        height: {xs: '28px', sm: 'calc(28px * 1.4)'},
                                        pt: {xs: '4px', sm: 'calc(4px * 1.4)'}
                                    }}/>
                                </div>
                                <div
                                    className={css`padding: 0 8px;
                                      height: 32px;

                                      ${media.sm} {
                                        height: calc(32px * 1.4)
                                      }
                                    ;
                                      background-color: #fff;
                                      border-radius: 4px`}>
                                    <Mastercard sx={{
                                        width: {xs: '40px', sm: 'calc(40px * 1.4)'},
                                        height: {xs: '28px', sm: 'calc(28px * 1.4)'},
                                        pt: {xs: '4px', sm: 'calc(4px * 1.4)'}
                                    }}/>
                                </div>
                                <div
                                    className={css`padding: 0 8px;
                                      height: 32px;

                                      ${media.sm} {
                                        height: calc(32px * 1.4)
                                      }
                                    ;
                                      background-color: #fff;
                                      border-radius: 4px`}>
                                    <Paysafecard sx={{
                                        width: {xs: '40px', sm: 'calc(40px * 1.4)'},
                                        height: {xs: '28px', sm: 'calc(28px * 1.4)'},
                                        pt: {xs: '4px', sm: 'calc(4px * 1.4)'}
                                    }}/>
                                </div>
                            </div>
                        </CustomLink>

                        <div
                            className={css`display: flex;
                              align-items: flex-start;
                              justify-conent: space-between;
                              margin-top: 16px;
                              width: 100%;
                              flex-direction: row;
                              flex-wrap: wrap;`}>
                            <Button component={CustomLink} to='/termsandconditions' sx={{
                                flexBasis: {xs: '50%', md: '20%'}, fontSize: '0.75rem',
                                justifyContent: 'center',
                                whiteSpace: 'nowrap',
                                color: (theme) => theme.palette.primary.contrastText
                            }}>{t('TermsAndConditions')}</Button>
                            <Button component={'a'}
                                    href={`https://support.peppermillcasino.be/${i18n.language}/support/home`}
                                    target={"_blank"}
                                    sx={{
                                        flexBasis: {xs: '50%', md: '20%'}, fontSize: '0.75rem',
                                        justifyContent: 'center',
                                        color: (theme) => theme.palette.primary.contrastText
                                    }}>{t('customerService')}</Button>
                            <Button component={CustomLink} to='/responsiblegaming' sx={{
                                flexBasis: {xs: '50%', md: '20%'}, fontSize: '0.75rem',
                                justifyContent: 'center',
                                color: (theme) => theme.palette.primary.contrastText
                            }}>{t('responsibleGaming')}</Button>
                            <Button component={'a'}
                                    href={`https://support.peppermillcasino.be/${i18n.language}/support/solutions`}
                                    target={"_blank"} sx={{
                                flexBasis: {xs: '50%', md: '20%'}, fontSize: '0.75rem',
                                justifyContent: 'center', minWidth: 0,
                                color: (theme) => theme.palette.primary.contrastText
                            }}>{t('faq')}</Button>
                            <Button component={CustomLink} to='/blog' sx={{
                                flexBasis: {xs: '50%', md: '20%'}, fontSize: '0.75rem',
                                justifyContent: 'center',
                                whiteSpace: 'nowrap',
                                color: (theme) => theme.palette.primary.contrastText
                            }}>{t('Blog')}</Button>
                        </div>

                        <div
                            className={css`display: none;
                              flex-direction: row;
                              align-items: center;
                              justify-content: center;
                              width: 100%;
                              margin-top: 16px;
                              flex-wrap: wrap;

                              ${media.md} {
                                display: flex
                              }
                            ;`}>
                            <Button component={'a'} target={'_blank'}
                                    href={`https://www.gamingcommission.be/${i18n.language.toLowerCase()}`}>
                                {i18n.language.toLowerCase() == 'nl' && <Kansspelcommissie
                                    sx={(theme) => ({
                                        height: 52,
                                        width: 'auto',
                                        color: (theme) => theme.palette.primary.main
                                    })} aria-hidden="false"/>}
                                {i18n.language.toLowerCase() == 'fr' && <CommissionDesJeuxDeHasard
                                    sx={(theme) => ({
                                        height: 60,
                                        width: 'auto',
                                        color: (theme) => theme.palette.primary.main
                                    })} aria-hidden="false"/>}
                                {i18n.language.toLowerCase() == 'en' && <GamingCommission
                                    sx={(theme) => ({
                                        height: 60,
                                        width: 'auto',
                                        color: (theme) => theme.palette.primary.main
                                    })} aria-hidden="false"/>}
                            </Button>
                            <div className={css`margin-left: 32px`}>
                                <MinimumAgeCasino/>
                            </div>
                            {i18n.language.toLowerCase() == 'nl' && (
                                <Button component={'a'} target={'_blank'} href={`https://www.stopoptijd.be/`}>
                                    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                         viewBox="60 20 340.56 60" className={css`height: 60px;
                                      fill: #d5a332;`}>
                                        <text transform="translate(65.56 44.44)">
                                            <tspan x="0" y="0">Gokken kan verslavend zijn. Stop op tijd!</tspan>
                                            <tspan x="38.82" y="25.2">Meer info op www.stopoptijd.be.</tspan>
                                        </text>
                                    </svg>
                                </Button>
                            )}

                            {i18n.language.toLowerCase() == 'fr' && (
                                <Button component={'a'} target={'_blank'} href={`https://www.arretezvousatemps.be/`}>
                                    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                         viewBox="50 20 385.56 80" className={css`height: 60px;
                                      fill: #d5a332;`}>
                                        <text transform="translate(124.85 31.84)">
                                            <tspan x="0" y="0">Le jeu peut rendre dépendant.</tspan>
                                            <tspan x="40.73" y="25.2">Arrêtez-vous à temps !</tspan>
                                            <tspan x="-111.41" y="50.4">Plus d&apos;informations sur
                                                www.arretezvousatemps.be.
                                            </tspan>
                                        </text>
                                    </svg>
                                </Button>
                            )}
                            {i18n.language.toLowerCase() == 'en' && (
                                <Button component={'a'} target={'_blank'} href={`https://www.stopoptijd.be/`}>
                                    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                         viewBox="60 20 340.56 60" className={css`height: 60px;
                                      fill: #d5a332;`}>
                                        <text transform="translate(67.34 44.44)">
                                            <tspan x="0" y="0">Gambling can be addictive. Stop in time!</tspan>
                                            <tspan x="39.41" y="25.2">More info at www.stopoptijd.be.</tspan>
                                        </text>
                                    </svg>
                                </Button>

                            )}
                            <div className={css`margin-left: 32px`}>
                                <HundredPercentSafe
                                    text={t('safe')}/>
                            </div>
                            <div className={css`margin-left: 32px`}>
                                <FastPayments
                                    text1={t('fastPayments1')}
                                    text2={t('fastPayments2')}/>
                            </div>
                            <div className={css`margin-left: 32px`}>
                                <BelgiumTag/>
                            </div>
                            <Button component={'a'} target={'_blank'} sx={{ml: 4}}
                                    href={`https://www.alwaysplaylegally.be/${(i18n.language == 'fr' || i18n.language == 'nl') ? i18n.language : ''}`}>
                                <AlwaysPlayLegally
                                    sx={(theme) => ({
                                        height: 52,
                                        width: 'auto',
                                        color: (theme) => theme.palette.primary.main
                                    })} aria-hidden="false"/>
                            </Button>

                            <div className={css`display: flex;
                              flex-direction: row`}>
                                <Typography
                                    sx={{
                                        mt: 2,
                                        ml: 4,
                                        fontSize: '13px',
                                        mr: '5px',
                                        textTransform: 'uppercase',
                                        color: (theme) => theme.palette.primary.main
                                    }}>Official<br/>Partner</Typography>
                                <Button component={'a'} target={'_blank'} href={`https://www.krcgenk.be/`}> <img
                                    src={`${process.env.NEXT_PUBLIC_CDN_URL}/krcgenk.webp`}
                                    alt={'KRC Genk'}
                                    className={css`height: 52px;
                                      width: auto;`}/>
                                </Button>
                                <Button component={'a'} target={'_blank'} href={`https://patroeisden.com/`}>
                                    <svg className={css`height: 100%;`} viewBox="0 0 1394.08 1892.13">
                                        <path className="cls-2"
                                              d="m1394.08,0v1195.09c0,186.19-72.49,361.23-204.15,492.89-131.66,131.63-306.7,204.15-492.89,204.15s-361.23-72.52-492.86-204.15C72.52,1556.32,0,1381.28,0,1195.09V0h1394.08Z"/>
                                        <path fill="#4c2c65" strokeWidth={0}
                                              d="m1365.26,28.82v1166.27c0,369.04-299.18,668.22-668.22,668.22S28.82,1564.13,28.82,1195.09V28.82h1336.44Z"/>
                                        <path fill={"#fff"} strokeWidth={0}
                                              d="m967.84,715.72c142.12,0,257.33-115.2,257.33-257.33v-58.11c0-142.12-115.2-257.33-257.33-257.33h-390.14v739.41l-131.99-139.68h-228.06l360.05,381.02v9.01l-360.05,381.02,120.48,113.85,239.57-253.52v298.33h236.57v-298.33l239.57,253.52,120.48-113.85-360.05-381.02v-9.01l360.05-381.02h-228.06l-131.99,139.68v-166.66h153.57Zm-153.57-394.29h71.59c46.4,0,84.05,37.64,84.05,84.05v41.5c0,46.4-37.64,84.05-84.05,84.05h-71.59v-209.6Z"/>
                                    </svg>
                                </Button>

                                <Button component={'a'} target={'_blank'} href={`https://www.hubolimburgunited.be/`}>
                                    <img src={`${process.env.NEXT_PUBLIC_CDN_URL}/hubolimburg.webp`}
                                         alt={'Hubo Limburg United'}
                                         className={css`height: 52px;
                                           width: auto;`}/>
                                </Button>
                            </div>

                        </div>

                        <div
                            className={css`display: flex;
                              flex-direction: column;
                              align-items: center;
                              justify-content: space-between;
                              width: 100%;
                              max-width: 600px;
                              margin-top: 16px;
                              flex-wrap: wrap;
                              align-self: center;

                              ${media.md} {
                                display: none
                              }
                            ;`}>
                            <div
                                className={css`display: flex;
                                  flex-direction: row;
                                  align-items: center;
                                  justify-content: center;
                                  width: 100%`}>
                                <Button component={'a'} target={'_blank'}
                                        href={`https://www.gamingcommission.be/${i18n.language.toLowerCase()}`}>
                                    {i18n.language.toLowerCase() == 'nl' && <Kansspelcommissie
                                        sx={(theme) => ({
                                            height: 40,
                                            width: 'auto',
                                            color: (theme) => theme.palette.primary.main
                                        })} aria-hidden="false"/>}
                                    {i18n.language.toLowerCase() == 'fr' && <CommissionDesJeuxDeHasard
                                        sx={(theme) => ({
                                            height: 40,
                                            width: 'auto',
                                            color: (theme) => theme.palette.primary.main
                                        })} aria-hidden="false"/>}
                                    {i18n.language.toLowerCase() == 'en' && <GamingCommission
                                        sx={(theme) => ({
                                            height: 40,
                                            width: 'auto',
                                            color: (theme) => theme.palette.primary.main
                                        })} aria-hidden="false"/>}
                                </Button>
                                {i18n.language.toLowerCase() == 'nl' && (
                                    <Button component={'a'} target={'_blank'} href={`https://www.stopoptijd.be/`}>
                                        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                             viewBox="60 20 340.56 60" className={css`height: 60px;
                                          fill: #d5a332;`}>
                                            <text transform="translate(65.56 44.44)">
                                                <tspan x="0" y="0">Gokken kan verslavend zijn. Stop op tijd!</tspan>
                                                <tspan x="38.82" y="25.2">Meer info op www.stopoptijd.be.</tspan>
                                            </text>
                                        </svg>
                                    </Button>
                                )}

                                {i18n.language.toLowerCase() == 'fr' && (
                                    <Button component={'a'} target={'_blank'}
                                            href={`https://www.arretezvousatemps.be/`}>
                                        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                             viewBox="50 20 385.56 80" className={css`height: 80px;
                                          width: 200px;
                                          fill: #d5a332;`}>
                                            <text transform="translate(124.85 31.84)">
                                                <tspan x="0" y="0">Le jeu peut rendre dépendant.</tspan>
                                                <tspan x="40.73" y="25.2">Arrêtez-vous à temps !</tspan>
                                                <tspan x="-111.41" y="50.4">Plus d&apos;informations sur
                                                    www.arretezvousatemps.be.
                                                </tspan>
                                            </text>
                                        </svg>
                                    </Button>
                                )}
                                {i18n.language.toLowerCase() == 'en' && (
                                    <Button component={'a'} target={'_blank'} href={`https://www.stopoptijd.be/`}>
                                        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                             viewBox="60 20 340.56 60" className={css`height: 60px;
                                          fill: #d5a332;`}>
                                            <text transform="translate(67.34 44.44)">
                                                <tspan x="0" y="0">Gambling can be addictive. Stop in time!</tspan>
                                                <tspan x="39.41" y="25.2">More info at www.stopoptijd.be.</tspan>
                                            </text>
                                        </svg>
                                    </Button>

                                )}


                            </div>
                            <div
                                className={css`display: flex;
                                  flex-direction: row;
                                  align-items: center;
                                  justify-content: center;
                                  width: 100%;
                                  margin-top: 16px`}>
                                <MinimumAgeCasino/>
                                <div className={css`margin-left: 16px`}>
                                    <HundredPercentSafe
                                        text={t('safe')}/>
                                </div>
                                <div className={css`margin-left: 16px`}>
                                    <FastPayments
                                        text1={t('fastPayments1')}
                                        text2={t('fastPayments2')}/>
                                </div>
                            </div>
                            <div
                                className={css`display: flex;
                                  flex-direction: row;
                                  align-items: center;
                                  justify-content: center;
                                  width: 100%;
                                  margin-top: 16px`}>
                                <div className={css`margin-left: 16px`}>
                                    <BelgiumTag/>
                                </div>
                                <Button component={'a'} target={'_blank'} sx={{ml: 2}}
                                        href={`https://www.alwaysplaylegally.be/${(i18n.language == 'fr' || i18n.language == 'nl') ? i18n.language : ''}`}>
                                    <AlwaysPlayLegally
                                        sx={(theme) => ({
                                            height: 40,
                                            width: 'auto',
                                            color: (theme) => theme.palette.primary.main
                                        })} aria-hidden="false"/>
                                </Button>
                            </div>
                            <div
                                className={css`display: flex;
                                  flex-direction: row;
                                  align-items: center;
                                  justify-content: center;
                                  width: 100%;
                                  margin-top: 16px`}>

                                <Typography
                                    sx={{
                                        fontSize: '13px',
                                        mr: '5px',
                                        textTransform: 'uppercase',
                                        color: (theme) => theme.palette.primary.main
                                    }}>Official<br/>Partner</Typography>
                                <Button component={'a'} target={'_blank'} href={`https://www.krcgenk.be/`}> <img
                                    src={`${process.env.NEXT_PUBLIC_CDN_URL}/krcgenk.webp`}
                                    alt={'KRC Genk'}
                                    className={css`height: 52px;
                                      width: auto;`}/>
                                </Button>
                                <Button component={'a'} target={'_blank'} href={`https://patroeisden.com/`}>
                                    <svg id="Layer_1" className={css`height: 100%;`} data-name="Layer 1"
                                         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1394.08 1892.13">
                                        <path className="cls-2"
                                              d="m1394.08,0v1195.09c0,186.19-72.49,361.23-204.15,492.89-131.66,131.63-306.7,204.15-492.89,204.15s-361.23-72.52-492.86-204.15C72.52,1556.32,0,1381.28,0,1195.09V0h1394.08Z"/>
                                        <path fill="#4c2c65" strokeWidth={0}
                                              d="m1365.26,28.82v1166.27c0,369.04-299.18,668.22-668.22,668.22S28.82,1564.13,28.82,1195.09V28.82h1336.44Z"/>
                                        <path fill={"#fff"} strokeWidth={0}
                                              d="m967.84,715.72c142.12,0,257.33-115.2,257.33-257.33v-58.11c0-142.12-115.2-257.33-257.33-257.33h-390.14v739.41l-131.99-139.68h-228.06l360.05,381.02v9.01l-360.05,381.02,120.48,113.85,239.57-253.52v298.33h236.57v-298.33l239.57,253.52,120.48-113.85-360.05-381.02v-9.01l360.05-381.02h-228.06l-131.99,139.68v-166.66h153.57Zm-153.57-394.29h71.59c46.4,0,84.05,37.64,84.05,84.05v41.5c0,46.4-37.64,84.05-84.05,84.05h-71.59v-209.6Z"/>
                                    </svg>
                                </Button>
                                <Button component={'a'} target={'_blank'} href={`https://www.hubolimburgunited.be/`}>
                                    <img src={`${process.env.NEXT_PUBLIC_CDN_URL}/hubolimburg.webp`}
                                         alt={'Hubo Limburg United'}
                                         className={css`height: 52px;
                                           width: auto;`}/>
                                </Button>

                            </div>
                        </div>

                        <div
                            className={css`display: flex;
                              flex-direction: row;
                              align-items: center;
                              justify-content: space-between;
                              width: 100%;
                              margin-top: 16px;
                              flex-wrap: wrap`}>
                            <Typography variant={'caption'}
                                        sx={{color: (theme) => theme.palette.grey[500], textAlign: 'center'}}>
                                {t('footerCompanyLicenseNumber')}
                            </Typography>
                        </div>

                        <div
                            className={css`display: flex;
                              flex-direciton: row;
                              align-items: center;
                              justify-content: space-between;
                              width: 100%;
                              margin-top: 16px;`}>
                            <div className={css`display: flex;
                              flex-direction: row;`}>
                                <Typography variant={'caption'}
                                            sx={{color: (theme) => theme.palette.grey[500], textAlign: 'center'}}>
                                    PepperMill Casino © 2022
                                </Typography>
                                <Typography variant={'caption'}
                                            sx={{
                                                color: (theme) => theme.palette.grey[500],
                                                textAlign: 'center',
                                                display: {xs: 'none', sm: 'flex'},
                                                ml: 1
                                            }}>
                                    {t('allRightsReserved')}
                                </Typography>
                            </div>
                            <Typography variant={'caption'} sx={{whiteSpace: 'nowrap'}}
                            >
                                <IconButton sx={{color: (theme) => theme.palette.primary.main, textAlign: 'center'}}
                                            component={'a'} href={'https://www.facebook.com/PepperMillcasino.be'}
                                            target={'_blank'}>
                                    <Facebook aria-hidden="false"/>
                                </IconButton>
                                <IconButton sx={{color: (theme) => theme.palette.primary.main, textAlign: 'center'}}
                                            component={'a'}
                                            href={'https://www.instagram.com/PepperMillcasino.be'}
                                            target={'_blank'}>
                                    <Instagram aria-hidden="false"/>
                                </IconButton>
                            </Typography>
                            <Typography variant={'caption'}
                                        sx={{color: (theme) => theme.palette.common.white, textAlign: 'center'}}>
                                <Link component={CustomLink}
                                      to={'/privacy'}>{t('privacyStatement')}</Link>&nbsp;|&nbsp;
                                <Link component={'button'} sx={{cursor: 'pointer'}}
                                      onClick={() => (window as any).cookiehub.openSettings()}>{t('cookieStatement')}</Link>
                            </Typography>
                        </div>
                    </div>
                </Container>
            </div>
        </footer>
    )

}


export default Footer;